import { Link } from "react-router-dom";
import { MessageCircle, Phone } from "lucide-react";
import { WHATSAPP_LINK, CALL_LINK } from "../data/content";

export default function MobileCtaBar() {
  return (
    <div
      data-testid="mobile-bottom-cta-bar"
      className="fixed inset-x-0 bottom-0 z-40 flex items-stretch border-t border-brass/20 bg-charcoal/95 backdrop-blur-xl md:hidden"
    >
      <a
        data-testid="mobile-bar-call-btn"
        href={CALL_LINK}
        aria-label="Call The Jamoon"
        className="flex items-center justify-center border-r border-brass/20 px-5 py-4 text-brass"
      >
        <Phone className="h-5 w-5" />
      </a>
      <a
        data-testid="mobile-bar-whatsapp-btn"
        href={WHATSAPP_LINK}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="WhatsApp The Jamoon"
        className="flex items-center justify-center border-r border-brass/20 px-5 py-4 text-brass"
      >
        <MessageCircle className="h-5 w-5" />
      </a>
      <Link
        data-testid="mobile-bar-plan-stay-btn"
        to="/plan"
        className="flex flex-1 items-center justify-center bg-brass py-4 text-[11px] font-semibold tracking-[0.2em] text-charcoal"
      >
        PLAN YOUR STAY
      </Link>
    </div>
  );
}
